export default "__VITE_ASSET__vI6B5pA5__"